import './translate-button.scss';
// import translation from '../../../../images/translation.svg';
import FontBody1 from '../../components/fonts/font-body1/font-body1';
import { FONT_COLOR, FONT_VARIANT } from '../../components/fonts/font-props';
import config from '../../config';
import Icon from '../icons/icon/icon';
import { ICON_SIZE } from '../icons/icon-props-interface';
import IconTranslationIndicator from '../icons/icon-translation-indicator/icon-translation-indicator';

export interface TranslationButtonProps {
    path: string;
    text?: string;
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const TranslateButton: React.FC<TranslationButtonProps> = (props: TranslationButtonProps) => {

    return (
        <a
            href={`${config.apiUrl}/${String(props.path).replace(/^\/+/, '')}`}
            target="_parent"
            className="translation-link-button"
            onClick={props.onClick}
        >

            <button type="button">
                <Icon Component={IconTranslationIndicator} size={ICON_SIZE.MEDIUM} color="var(--color-accent-1)" />
                <FontBody1 color={FONT_COLOR.ACCENT1} variant={[FONT_VARIANT.BOLD, FONT_VARIANT.UPPERCASE]}>
                    { props.text ?? 'Translate'}
                </FontBody1>
            </button>
        </a>
    );

}
